// if ($(window).width() > 768) {
    $("#cart-icon-bubble").on('click', function (e) {
        e.preventDefault();
        $("body").addClass('cart-open');
    })

    function closeCart() {
        $("body").removeClass('cart-open');
    }

    $(".overlay").on("click", function () {
        $("body").removeClass('cart-open');
    })
// }


function sectionRedering() {
    fetch("?section_id=cart-drawer-test")
        .then((res) => res.text())
        .then((data) => {
            var cart__html = $(data);
            var render__html = $(".cart-drawer__inner", cart__html);
            $(".cart-drawer__inner").replaceWith(render__html);

        });

    // header 
    // header section 
    fetch("?section_id=header")
        .then((res) => res.text())
        .then((data) => {
            var cart__html = $(data);
            var render__html = $(".cart-count-bubble", cart__html);
            $(".cart-count-bubble").replaceWith(render__html);
        });

}




// increment quantity in cart drawer
function increment(el) {
    var input = el.previousElementSibling;
    var value = parseInt(input.value);
    console.log(value)
    value = isNaN(value) ? 0 : value
    value++;
    input.value = value;
    changeQuantity(input);

}
// decrement quantity in cart drawer
function decrement(el) {
    var input = el.nextElementSibling;
    var value = parseInt(input.value);
    if (value > 0) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
        changeQuantity(input);
    }
}

function changeQuantity(input) {

    var quantity = $(input).val();
    var data_line = $(input).attr("data-line");
    var data = {
        "line": data_line,
        "quantity": quantity
    };
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: data,
        success: function (data) {
            console.log(data);
            sectionRedering();
        },
        error: function (err) {
            console.log("Error from quantity update")
        }
    })


}


function removeItem(event, el) {
    event.preventDefault();
    var data_line = $(el).attr("data-line");
    console.log(data_line)
    var deleteData = {
        "line": data_line,
        "quantity": 0
    };

    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: deleteData,
        success: function (data) {

            sectionRedering();
        }
    })
}